<script src="//unpkg.com/v-viewer/dist/v-viewer.js"></script>

<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row>
          <b-col md="6">
            <b-form-group>
              <template #label> Store reason <span class="text-danger">*</span> </template>
              <b-form-textarea
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                v-model="form.storeReason"
                placeholder="Enter Store Reason"
                :disabled="!isEditableFieldsEnabled"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label> Store Resolution <span class="text-danger">*</span> </template>
              <b-form-textarea
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                v-model="form.storeResolution"
                placeholder="Enter Store Resolution"
                :disabled="!isEditableFieldsEnabled"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <template #label> RCA <span class="text-danger">*</span> </template>
              <b-form-textarea
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                v-model="form.rca"
                placeholder="Enter RCA"
                :disabled="!isEditableFieldsEnabled"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <template #label> Corrective measures <span class="text-danger">*</span> </template>
              <b-form-textarea
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                v-model="form.correctiveMeasures"
                placeholder="Enter corrective measures"
                :disabled="!isEditableFieldsEnabled"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <template #label> Time of Store Resolution by Store <span class="text-danger">*</span> </template>
              <b-input-group class="box-shadow2">
                <b-input-group-append>
                  <b-form-datepicker
                    button-only
                    id="input-timeOfStoreResolutionByStore"
                    placeholder="Select Date"
                    :min="minDate"
                    :max="maxDate"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    v-model="form.timeOfStoreResolutionByStore"
                    :disabled="!isEditableFieldsEnabled"
                    class="box-shadow3"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-form-input
                  id="display-timeOfStoreResolutionByStore"
                  :value="formatDisplayDate(form.timeOfStoreResolutionByStore)"
                  type="text"
                  placeholder="Select Date"
                  autocomplete="off"
                  :class="{
                    '': !isDarkMode,
                    'bg-dark text-light placeholder-light': isDarkMode
                  }"
                  disabled
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label> Action <span class="text-danger">*</span> </template>
              <b-form-select
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                v-model="form.action"
                :options="actionOptions"
                :disabled="!isEditableFieldsEnabled"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.supportingImageUrl">
          <b-col md="6">
            <div v-viewer>
              <b-form-group id="group-supporting-image" label-for="supporting-image">
                <template v-slot:label>
                  Uploaded Supporting Image
                  <span class="text-danger">*</span>
                </template>
                <!-- Upload Input -->
                <!-- <input
                  v-if="!isUpdateForm && isSupportingImageUploadEnabled"
                  type="file"
                  accept="image/*"
                  @change="uploadFile($event, 'supportingImageUrl')"
                /> -->

                <!-- Preview -->
                <div class="mt-2 imageView">
                  <img
                    :src="form.supportingImageUrl"
                    alt="Supporting Image"
                    class="mx-2"
                    style="width: 120px; height: 120px; object-fit: contain"
                  />
                  <link href="//unpkg.com/viewerjs/dist/viewer.css" rel="stylesheet" />
                </div>

                <!-- Notes -->
                <b-row>
                  <b-form-text v-if="isSupportingImageUploadEnabled && !form.supportingImageUrl">
                    Note: Upload supporting image related to CX Pulse 360
                  </b-form-text>

                  <b-form-text v-if="!isSupportingImageUploadEnabled && !form.supportingImageUrl" class="text-muted">
                    Image upload disabled (status is closed)
                  </b-form-text>
                </b-row>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Ticket Owner">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.ticketOwner"
                placeholder="Enter Ticket Owner"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Customer Name">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.customerName"
                placeholder="Enter Customer Name"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Ticket Number">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.ticketNumber"
                placeholder="Enter Ticket Number"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Customer Mobile">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.customerMobile"
                placeholder="Enter Customer Mobile"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Customer Email">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.customerEmail"
                placeholder="Enter Customer Email"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Convox Form Type">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.convoxFormType"
                placeholder="Enter Convox Form Type"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Assigned By">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.assignedBy"
                placeholder="Enter Assigned By"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Platform Type">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.platformType"
                placeholder="Enter Platform Type"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Store Id">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.storeId"
                placeholder="Enter Store Id"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Store Manager">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.storeManager"
                placeholder="Enter Store Manager"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Reference Number">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.referenceNumber"
                placeholder="Enter Reference Number"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Bill Date">
              <b-input-group class="box-shadow2">
                <b-input-group-append>
                  <b-form-datepicker
                    button-only
                    id="input-billDate"
                    placeholder="Select Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    v-model="form.billDate"
                    :disabled="isOtherFieldsDisabled"
                    class="box-shadow3"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-form-input
                  id="display-billDate"
                  :value="formatDisplayDate(form.billDate)"
                  type="text"
                  placeholder="Select Date"
                  autocomplete="off"
                  :class="{
                    '': !isDarkMode,
                    'bg-dark text-light placeholder-light': isDarkMode
                  }"
                  disabled
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Bill Number">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.billNumber"
                placeholder="Enter Bill Number"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Attachment URL">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.attachmentURL"
                placeholder="Attachment link from API"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
              <a
                v-if="form.attachmentURL"
                :href="form.attachmentURL"
                target="_blank"
                rel="noopener noreferrer"
                class="small mt-1 d-block"
              >
                Open link
              </a>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Store Name">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.storeName"
                placeholder="Enter Store Name"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Region">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.region"
                placeholder="Enter Region"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="State">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.state"
                placeholder="Enter State"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="City">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.city"
                placeholder="Enter City"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Assign To Store">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.assignToStore"
                placeholder="Enter Assign To Store"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Feedback Type">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.feedbackType"
                placeholder="Enter Feedback Type"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Feedback Class">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.feedbackClass"
                placeholder="Enter Feedback Class"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Feedback Sub Class">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.feedbackSubClass"
                placeholder="Enter Feedback Sub Class"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- Region For Complain field commented out
          <b-col md="6">
            <b-form-group label="Reason For Complain">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.regionForComplain"
                placeholder="Enter Region For Complain"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          -->
          <b-col md="6">
            <b-form-group label="Modified By">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.modifiedBy"
                placeholder="Enter Modified By"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Team">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.team"
                placeholder="Enter Team"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Department">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.department"
                placeholder="Enter Department"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Open Since">
              <b-form-input
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                type="text"
                v-model="form.openSince"
                placeholder="Enter Open Since"
                :disabled="isOtherFieldsDisabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Share your feedback">
              <b-form-textarea
                :class="{
                  'box-shadow3 text-dark': !isDarkMode,
                  'bg-light': !isDarkMode && !isOtherFieldsDisabled,
                  'bg-grey': !isDarkMode && isOtherFieldsDisabled,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                v-model="form.share_your_feedback"
                placeholder="Enter Share Your Feedback"
                :disabled="isOtherFieldsDisabled"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- <b-row>
          <b-col md="6">
            <b-form-group label="Updated At">
              <b-form-input :class="{
                'box-shadow3 bg-light text-dark': !isDarkMode,
                'bg-dark text-light placeholder-light': isDarkMode
              }" type="text" v-model="form.updatedAt" placeholder="Updated At" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->

        <b-form-group>
          <b-row class="mt-2">
            <b-col class="text-right">
              <b-button
                type="submit"
                size="sm"
                :variant="isDarkMode ? 'outline-success' : 'success'"
                :disabled="loading || isAllFieldsDisabled || !isRCAandCorrectiveMeasures"
              >
                <span class="spinner spinner-white" v-if="loading"></span>
                <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
              </b-button>
              <b-button
                class="ml-2"
                size="sm"
                :variant="isDarkMode ? 'outline-warning' : 'warning'"
                :to="{ path: `/cx-pulse-360` }"
              >
                <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import VueViewer from 'v-viewer';
import Vue from 'vue';
import router from '@/router';

Vue.use(VueViewer);

export default {
  name: 'TmsFormBox',
  components: {
    Multiselect
  },
  props: {
    listUrl: String,
    formType: String,
    feedbackType: String
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      title: '',
      formLoaded: true,
      loadedAction: null,
      minDate: moment('2020-01-01').format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD'),
      actionOptions: [
        { value: null, text: 'Select Action' },
        { value: 'Pending', text: 'Pending' },
        { value: 'Closed', text: 'Closed' }
      ],
      form: {
        customerName: '',
        customerMobile: '',
        customerEmail: '',
        correctiveMeasures: '',
        ticketOwner: '',
        assignedBy: '',
        platformType: '',
        storeId: '',
        storeName: '',
        region: '',
        state: '',
        city: '',
        storeManager: '',
        referenceNumber: '',
        billDate: null,
        billNumber: '',
        share_your_feedback: '',
        openSince: '',
        assignToStore: '',
        feedbackType: '',
        feedbackClass: '',
        feedbackSubClass: '',
        supportingImageUrl: '',
        attachmentURL: '',
        regionForComplain: '',
        storeResolution: '',
        timeOfStoreResolutionByStore: null,
        action: null,
        storeReason: '',
        rca: '',
        ticketNumber: '',
        modifiedBy: '',
        convoxFormType: '',
        department: '',
        team: '',
        updatedAt: ''
      }
    };
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new CX Pulse 360' : 'Update CX Pulse 360';
    },
    isLoadedActionClosed() {
      return this.loadedAction && String(this.loadedAction).toLowerCase() === 'closed';
    },
    isAllFieldsDisabled() {
      if (this.formType === 'new') return false;
      return this.isLoadedActionClosed;
    },
    isRCAandCorrectiveMeasures() {
      return (
        this.form.rca &&
        this.form.correctiveMeasures &&
        this.form.storeReason &&
        this.form.storeResolution &&
        this.form.timeOfStoreResolutionByStore
      );
    },
    isOtherFieldsDisabled() {
      if (this.formType === 'new') return false;
      return true;
    },
    isEditableFieldsEnabled() {
      if (this.formType === 'new') return true;
      return !this.isLoadedActionClosed;
    },
    isSupportingImageUploadEnabled() {
      if (this.formType === 'new') return true;
      return !this.isLoadedActionClosed;
    },
    ...mapState('tms', ['loading', 'tms', 'uploadedImages']),
    ...mapState('auth', ['user']),
    ...mapState('darkMode', ['isDarkMode'])
  },
  methods: {
    ...mapActions('tms', ['list', 'postOne', 'getOne', 'patchOne', 'uploadImage']),

    uploadFile(event, urlName) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (!file || !file.type.includes('image')) {
          event.target.value = '';
          alert('Only image files are allowed.');
          return;
        }
        this.uploadImage({ file, urlName }, {}, router);
      }
      event.target.value = '';
    },
    toDatePickerFormat(value) {
      if (!value) return null;
      const parsed = moment(value, ['DD-MM-YYYY', moment.ISO_8601], true);
      return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
    },
    formatDisplayDate(value) {
      if (!value) return '';
      const parsed = moment(value, ['YYYY-MM-DD', moment.ISO_8601], true);
      return parsed.isValid() ? parsed.format('DD-MM-YYYY') : value;
    },
    toApiDate(value) {
      if (!value) return value;
      const parsed = moment(value, ['YYYY-MM-DD', 'DD-MM-YYYY', moment.ISO_8601], true);
      return parsed.isValid() ? parsed.toISOString() : value;
    },
    onSubmit() {
      const tms = { ...this.form };
      if (tms.billDate) tms.billDate = this.toApiDate(tms.billDate);
      if (tms.timeOfStoreResolutionByStore)
        tms.timeOfStoreResolutionByStore = this.toApiDate(tms.timeOfStoreResolutionByStore);
      if (this.formType === 'new') {
        this.$emit('add', { tms });
      } else {
        this.$emit('edit', { tms });
      }
      return false;
    }
  },
  watch: {
    formType: {
      immediate: true,
      handler(val) {
        if (val === 'new') {
          this.$store.commit('tms/clearUploadedImages');
        }
      }
    },
    uploadedImages(newValue) {
      if (newValue && newValue.supportingImageUrl) {
        this.form.supportingImageUrl = newValue.supportingImageUrl;
      }
    },
    tms(newValue) {
      if (newValue && newValue.id) {
        this.loadedAction = newValue.action || null;
        this.form.customerName = newValue.customerName || '';
        this.form.customerMobile = newValue.customerMobile || '';
        this.form.customerEmail = newValue.customerEmail || '';
        this.form.ticketOwner = newValue.ticketOwner || '';
        this.form.assignedBy = newValue.assignedBy || '';
        this.form.platformType = newValue.platformType || '';
        this.form.storeId = newValue.storeId || '';
        this.form.storeName = newValue.storeName || '';
        this.form.region = newValue.region || '';
        this.form.state = newValue.state || '';
        this.form.city = newValue.city || '';
        this.form.storeManager = newValue.storeManager || '';
        this.form.referenceNumber = newValue.referenceNumber || '';
        this.form.billDate = this.toDatePickerFormat(newValue.billDate);
        this.form.billNumber = newValue.billNumber || '';
        this.form.share_your_feedback = newValue.share_your_feedback || '';
        this.form.openSince = newValue.openSince || '';
        this.form.assignToStore = newValue.assignToStore || '';
        this.form.feedbackType = newValue.feedbackType || '';
        this.form.feedbackClass = newValue.feedbackClass || '';
        this.form.feedbackSubClass = newValue.feedbackSubClass || '';
        this.form.supportingImageUrl = newValue.supportingImageUrl || '';
        this.form.attachmentURL = newValue.attachmentURL || '';
        this.form.regionForComplain = newValue.regionForComplain || '';
        this.form.storeResolution = newValue.storeResolution || '';
        this.form.timeOfStoreResolutionByStore = this.toDatePickerFormat(newValue.timeOfStoreResolutionByStore);
        this.form.correctiveMeasures = newValue.correctiveMeasures || '';
        this.form.rca = newValue.rca || '';
        this.form.storeReason = newValue.storeReason || '';
        this.form.action = newValue.action || null;
        this.form.ticketNumber = newValue.ticketNumber || '';
        this.form.modifiedBy = newValue.modifiedBy || '';
        this.form.convoxFormType = newValue.convoxFormType || '';
        this.form.department = newValue.department || '';
        this.form.team = newValue.team || '';
        this.form.updatedAt = newValue.updatedAt || '';
      }
      this.formLoaded = true;
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.calender {
  display: flex;
  width: auto;
  margin-left: -9px;
  margin-bottom: 0.7rem;
}
</style>
<style scoped>
.imageView {
  display: inline-flex;
  margin: 2px;
}
</style>
